import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHourglassOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6 2V6.88C6 7.65 6.36 8.38 6.98 8.85L10.5 11.5C11.39 12.17 12.61 12.17 13.5 11.5L17.02 8.85C17.64 8.38 18 7.66 18 6.88V2H6Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 22V17.12C18 16.35 17.64 15.62 17.02 15.15L13.5 12.5C12.61 11.83 11.39 11.83 10.5 12.5L6.98 15.15C6.36 15.62 6 16.34 6 17.12V22H18Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 22H8.5C8.5 21.45 8.95 21 9.5 21H14.5C15.05 21 15.5 21.45 15.5 22Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.75 22H19.25",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.75 2H19.25",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgHourglassOutline;
